import React from 'react';
import {View} from 'MWC';
import tpl from '../templates/faq.jsx';

export default class extends View {
    templates = {
        [this.uiStates.INITIAL]: <div />,
        [this.uiStates.INTERACTIVE]: tpl,
        [this.uiStates.ERROR]: tpl,
        [this.uiStates.STANDBY]: tpl
    };

    constructor(props) {
        super(props);

        this.state = {
            ui: this.uiStates.INITIAL,
            fullMode: false
        };

        this.toggleFAQMode = this.toggleFAQMode.bind(this);
    }

    toggleFAQMode() {
        this.setState(prevState => {
            return {
                fullMode: !prevState.fullMode
            };
        });
    }

    static defaultProps = {
        shortModeLength: 1
    };
}
